import clsx from "clsx";
import React, {
  DetailedHTMLProps,
  forwardRef,
  InputHTMLAttributes,
  PropsWithChildren,
} from "react";

import { colorScheme } from "../styles";
import { TagColors, TagDimensions, TagVariants } from "../types";
import { dimensionsScheme } from "./styles";

export interface PillProps
  extends DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement> {
  color: TagColors;
  uncheckedColor?: TagColors;
  dimension?: TagDimensions;
  variant?: TagVariants;
}

export const Pill = forwardRef<HTMLInputElement, PropsWithChildren<PillProps>>(
  (
    {
      children,
      dimension = TagDimensions.Large,
      variant = TagVariants.Light,
      uncheckedColor = TagColors.Neutral,
      color,
      className,
      ...rest
    },
    ref
  ) => {
    const { labelColorClassName } = colorScheme[variant][rest.checked ? color : uncheckedColor];
    const { labelDimensionClassName } = dimensionsScheme[dimension];
    return (
      <label
        className={clsx(
          "rounded-full flex items-center justify-center select-none",
          labelColorClassName,
          labelDimensionClassName,
          (rest.onChange ?? rest.onClick) && "cursor-pointer",
          className
        )}
      >
        <input type="checkbox" className="hidden" {...rest} ref={ref} />
        <span className="whitespace-nowrap truncate">{children}</span>
      </label>
    );
  }
);
